import { useQuery } from "@tanstack/react-query";
import { ApiGetPlatFormConfig } from "@/api";

export const usePlatFormConfig = () => {
  return useQuery({
    queryKey: ["getPlatFormConfig"],
    queryFn: async () => {
      const res = await ApiGetPlatFormConfig();
      console.log("ApiGetPlatFormConfig", res.data);
      return {
        ...res.data,
      };
    },
    staleTime: 0,
    gcTime: 0,
  });
};
